// Copyright 2025, University of Maryland, All Rights Reserved
import React from "react"
import { BaseField, type BaseFieldEditorProps } from "./BaseField.tsx"

export const SimpleArrayFieldEditor = React.memo((props: BaseFieldEditorProps) => {
  return (
    <BaseField {...props}>
      <div className="text-xs text-muted-foreground">
        This field will accept a list of text values in the generated schema.
      </div>
    </BaseField>
  )
})

SimpleArrayFieldEditor.displayName = 'SimpleArrayFieldEditor'
